const OZTRAIL_AU_B2B_ENABLED = false;

function hasCompletedAlgoliaQuery(state) {
  return state.status === 'idle' && state.query.trim().length > 0;
}

// ***************************************************************
// ***                Auto Complete custom hooks               ***
// ***************************************************************
document.addEventListener('algolia.hooks.initialize', function () {
  algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function(options) {
    algoliaShopify.config.show_products = true; //ensure the results are distinct by plp title
    algoliaShopify.translations.collections = "Shop by Category";
    // Phones get a shorter prompt that fits the bar down to 320px wide; the full one is cut off below about 400px.
    // Both are set in Theme settings > Navigation (window.oztNavSearchPrompt, output by the header)
    const prompts = window.oztNavSearchPrompt || {};
    options.placeholder = window.matchMedia("(max-width: 749px)").matches
      ? prompts.phone || "Search gazebos, tents & more"
      : prompts.desktop || "Search gazebos, tents, furniture and more!";
    // Show popular suggestions and top products as soon as the box is tapped, not only after typing
    options.openOnFocus = true;

    //Debounce
    function debouncePromise(func, time) {
      let timerId = undefined;
      return function debounced(...args) {
        if (timerId) {
          clearTimeout(timerId);
        }

        return new Promise((resolve) => {
          timerId = setTimeout(() => resolve(func, ...args), time);
        });
      };
    }

    const debounced = debouncePromise((items) => Promise.resolve(items), 300);
    options.getSources = function ({ query, setContext }) {
      return [
        {
          sourceId: "products",
          getItems() {
            return debounced(
              algoliaShopify.externals.getAlgoliaResults({
                searchClient: algoliaShopify.searchClient,
                queries: [
                  {
                    indexName: `${algoliaShopify.config.index_prefix}products`,
                    query,
                    params: {
                      query,
                      hitsPerPage: 4,
                    },
                  },
                ], 
              })
            );
          },
          templates: {
            noResults(templateOptions) {
              const { html, state } = templateOptions;
              // Opening on focus has no items until the default sources arrive.
              if (!hasCompletedAlgoliaQuery(state)) return null;
              return html`<div class="aa-PanelLayout aa-Panel--scrollable">
                        <p class="aa-NoResultsHeader">
                          ${algoliaShopify.translation_helpers.no_result_for(state.query)}
                        </p>
                        <a class="aa-NoResultsLink" href="/collections/all">
                          Shop All
                        </a>
                      </div>`;
            },
            item({ item, html }) {
              const hitPriceData = priceData(item);
              const productMeta = item.meta && item.meta.product ? item.meta.product : {};
              const tags = Array.isArray(item.tags) ? item.tags : [];

              const customSaleBadgeIsActive = displayCustomSalesBadge(
                productMeta.sale_badge_text || '',
                productMeta.sale_start_date || '',
                productMeta.sale_end_date || ''
              );
              const freeGift = item.meta?.custom?.free_gift_gifts;
              const showFreeGiftBadge =
                Boolean(freeGift) &&
                (item.inventory_available > 0 || item.inventory_policy === 'continue');

              const primaryBadgeSearch =
                item.inventory_available > 0 ||
                item.inventory_policy === 'continue' ||
                item.product_type === 'Gift Cards'
                  ? (
                      OZTRAIL_AU_B2B_ENABLED
                        ? (
                            hitPriceData.clearance
                              ? html`
                                  <span class="badge aa-badge badge--bottom-left color-clearance-badge">
                                    Clearance
                                  </span>
                                `
                              : ''
                          )
                        : (
                            customSaleBadgeIsActive &&
                            item.compare_at_price > item.price &&
                            productMeta.display_both_sale_badges === true
                              ? html`
                                  <span class="badge aa-badge badge--bottom-left color-sale-badge">
                                    Sale
                                  </span>
                                  <span class="badge aa-badge badge--bottom-left color-custom-sale-badge">
                                    ${productMeta.sale_badge_text}
                                  </span>
                                `
                              : customSaleBadgeIsActive
                                ? html`
                                    <span class="badge aa-badge badge--bottom-left color-custom-sale-badge">
                                      ${productMeta.sale_badge_text}
                                    </span>
                                  `
                                : (
                                    item.compare_at_price > item.price &&
                                    tags.includes('Clearance')
                                      ? html`
                                          <span class="badge aa-badge badge--bottom-left color-clearance-badge">
                                            Clearance
                                          </span>
                                        `
                                      : ''
                                  )
                          )
                    )
                  : (
                      tags.includes('Exclusive to Anaconda') ||
                      tags.includes('Online Exclusive')
                        ? ''
                        : html`
                            <span class="badge aa-badge badge--bottom-left color-sold-out-badge">
                              ${algoliaShopify.translations.outOfStock}
                            </span>
                          `
                    );

              const isNewArrival = tags.includes('New Arrivals');

              const isExclusive = tags.includes('Website Only');
              const isExclusiveToAnaconda = !isExclusive && tags.includes('Exclusive to Anaconda');
              const isExclusiveToBCF =
                !isExclusive &&
                !isExclusiveToAnaconda &&
                tags.includes('Online Exclusive');
              
              const isBestSeller = 
                    !isNewArrival && !isExclusive && !isExclusiveToAnaconda && !isExclusiveToBCF &&
                    tags.includes('Best Seller');

              const isTeamsPick = 
                    !isNewArrival && !isExclusive && !isExclusiveToAnaconda && !isExclusiveToBCF && !isBestSeller && 
                    tags.includes('Teams Pick');

              
              const customBadges = {
                1: null,
                2: null,
                3: null,
                4: null,
                5: null
              };

              const customBadgePositions = {
                1: 'row',
                2: 'row',
                3: 'row',
                4: 'row',
                5: 'row'
              };

              if (typeof item.named_tags === 'object' && item.named_tags !== null) {
                for (let i = 1; i <= 5; i++) {
                  const key = `Custom Badge ${i}`;
                  const value = item.named_tags[key];
                  const positionValue = item.named_tags[`${key} Position`];
                  const normalizedPosition =
                    typeof positionValue === 'string'
                      ? positionValue.trim().toLowerCase()
                      : '';

                  customBadges[i] = value && value.trim() !== '' ? value.trim() : null;

                  if (normalizedPosition === 'top left') {
                    customBadgePositions[i] = 'top-left';
                  } else if (normalizedPosition === 'bottom left') {
                    customBadgePositions[i] = 'bottom-left';
                  }
                }
              }

              const percentOffFlag = getPercentOffFlag(item, hitPriceData);
              // The dropdown image is too small for a flag and a note, so the note moves clear of the product
              if (percentOffFlag) {
                Object.keys(customBadgePositions).forEach(function (badgeNumber) {
                  if (customBadgePositions[badgeNumber] === 'top-left') {
                    customBadgePositions[badgeNumber] = 'bottom-left';
                  }
                });
              }

              const hasTopLeftCustomBadges = Object.keys(customBadges).some(function (badgeNumber) {
                return customBadges[badgeNumber] && customBadgePositions[badgeNumber] === 'top-left';
              });
              const hasBottomLeftCustomBadges = Object.keys(customBadges).some(function (badgeNumber) {
                return customBadges[badgeNumber] && customBadgePositions[badgeNumber] === 'bottom-left';
              });

              const priceClass = hitPriceData.catalog_price
                ? 'aa-ItemContentPriceB2B'
                : 'aa-ItemContentPriceSale';

              return html`
                <a
                  href="/products/${item.handle}"
                  class="aa-ItemLink aa-ProductItem"
                  onClick="${() => algoliaShopify.helpers.handleItemClick(item)}"
                >
                  <div class="aa-ItemContent">
                    <div class="aa-ItemPicture aa-ItemPicture--loaded">
                      <img src="${algoliaShopify.helpers.compactImage(item)}" alt="${plpTitle(item)}" />
                      ${(percentOffFlag || hasTopLeftCustomBadges) && html`
                        <span class="aa-ItemBadgeOverlay aa-ItemBadgeOverlay--top-left">
                          ${percentOffFlag && html`<span class="badge color-custom-sale-badge percent-off-flag">${percentOffFlag}</span>`}
                          ${customBadges[1] && customBadgePositions[1] === 'top-left' && html`<span class="badge color-custom-badge-1">${customBadges[1]}</span>`}
                          ${customBadges[2] && customBadgePositions[2] === 'top-left' && html`<span class="badge color-custom-badge-2">${customBadges[2]}</span>`}
                          ${customBadges[3] && customBadgePositions[3] === 'top-left' && html`<span class="badge color-custom-badge-3">${customBadges[3]}</span>`}
                          ${customBadges[4] && customBadgePositions[4] === 'top-left' && html`<span class="badge color-custom-badge-4">${customBadges[4]}</span>`}
                          ${customBadges[5] && customBadgePositions[5] === 'top-left' && html`<span class="badge color-custom-badge-5">${customBadges[5]}</span>`}
                        </span>
                      `}
                      ${hasBottomLeftCustomBadges && html`
                        <span class="aa-ItemBadgeOverlay aa-ItemBadgeOverlay--bottom-left">
                          ${customBadges[1] && customBadgePositions[1] === 'bottom-left' && html`<span class="badge color-custom-badge-1">${customBadges[1]}</span>`}
                          ${customBadges[2] && customBadgePositions[2] === 'bottom-left' && html`<span class="badge color-custom-badge-2">${customBadges[2]}</span>`}
                          ${customBadges[3] && customBadgePositions[3] === 'bottom-left' && html`<span class="badge color-custom-badge-3">${customBadges[3]}</span>`}
                          ${customBadges[4] && customBadgePositions[4] === 'bottom-left' && html`<span class="badge color-custom-badge-4">${customBadges[4]}</span>`}
                          ${customBadges[5] && customBadgePositions[5] === 'bottom-left' && html`<span class="badge color-custom-badge-5">${customBadges[5]}</span>`}
                        </span>
                      `}
                    </div>
                    <div class="aa-ItemContentBody">
                      <div class="aa-ItemContentWrapper">
                        <div class="aa-ItemContentVendor">
                          ${item.vendor}
                        </div>
                        <div class="aa-ItemContentTitleModel">
                          ${plpTitleModel(item)}
                        </div>

                        <div class="aa-ItemContentPriceCurrent">
                          ${hitPriceData.display_compare_at_price
                            ? html`
                                <span class="aa-ItemContentPriceStrike">
                                  ${hitPriceData.display_compare_at_price_formatted}
                                </span>
                                <span class="${priceClass}">
                                  ${hitPriceData.display_price_formatted}
                                </span>
                              `
                            : html`
                                <span class="${hitPriceData.catalog_price ? 'aa-ItemContentPriceB2B' : ''}">
                                  ${hitPriceData.display_price_formatted}
                                </span>
                              `}
                        </div>

                        ${hitPriceData.display_club_price && html`
                          <div class="aa-ItemContentClubPrice">
                            <span class="aa-ItemContentClubPriceLabel">
                              ${hitPriceData.club_price_applied && html`<svg class="club-price-tick" viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M2 6.4l2.6 2.6L10 3.4" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>`}
                              Club Price
                            </span>
                            <span class="aa-ItemContentClubPriceValue">
                              ${hitPriceData.club_price_applied
                                ? `Saving ${hitPriceData.club_saving_formatted}`
                                : hitPriceData.display_club_price_formatted}
                            </span>
                            ${!hitPriceData.club_price_applied && html`<span class="club-price-info" role="button" tabindex="0" aria-haspopup="dialog" aria-expanded="false" aria-label="What is Club price?">
                              <svg class="club-price-info__icon" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><circle cx="8" cy="8" r="7" fill="none" stroke="currentColor" stroke-width="1.5"></circle><circle cx="8" cy="4.8" r="1" fill="currentColor"></circle><path d="M8 7.2v4.6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"></path></svg>
                            </span>`}
                          </div>
                        `}

                        ${!hitPriceData.display_club_price && html`
                        <div class="card__badge top left">
                          ${primaryBadgeSearch}
                          ${!primaryBadgeSearch && html`
                            ${isNewArrival && html`<span class="badge aa-badge badge--bottom-left color-new-arrivals-badge">New</span>`}
                            ${isExclusive && html`<span class="badge aa-badge badge--bottom-left color-exclusive-badge">Exclusive</span>`}
                            ${isExclusiveToAnaconda && html`<span class="badge aa-badge badge--bottom-left color-exclusive-badge">Exclusive To Anaconda</span>`}
                            ${isExclusiveToBCF && html`<span class="badge aa-badge badge--bottom-left color-exclusive-badge">Exclusive To BCF</span>`}
                            ${isTeamsPick && html`<span class="badge aa-badge badge--bottom-left color-teams-pick-badge">Teams Pick</span>`}
                            ${isBestSeller && html`<span class="badge aa-badge badge--bottom-left color-best-seller-badge">Best Seller</span>`}
                            ${customBadges[1] && customBadgePositions[1] === 'row' && html`<span class="badge aa-badge badge--bottom-left color-custom-badge-1">${customBadges[1]}</span>`}
                            ${customBadges[2] && customBadgePositions[2] === 'row' && html`<span class="badge aa-badge badge--bottom-left color-custom-badge-2">${customBadges[2]}</span>`}
                            ${customBadges[3] && customBadgePositions[3] === 'row' && html`<span class="badge aa-badge badge--bottom-left color-custom-badge-3">${customBadges[3]}</span>`}
                            ${customBadges[4] && customBadgePositions[4] === 'row' && html`<span class="badge aa-badge badge--bottom-left color-custom-badge-4">${customBadges[4]}</span>`}
                            ${customBadges[5] && customBadgePositions[5] === 'row' && html`<span class="badge aa-badge badge--bottom-left color-custom-badge-5">${customBadges[5]}</span>`}
                          `}
                          ${showFreeGiftBadge && html`<span class="badge aa-badge badge--bottom-left color-free-gift-badge">Free Gift</span>`}
                        </div>
                        `}
                      </div>
                    </div>
                  </div>
                </a>`;
            },
            header(templateOptions) {
              const { html, state } = templateOptions;
              return html`
                <div class="aa-SourceHeader">
                  <span class="aa-SourceHeaderTitle">Products</span>
                </div>
              `;
            },
            footer(templateOptions) {
              const { html, state } = templateOptions;
              const hasQuery = state.query.trim().length > 0;
              const destination = hasQuery
                ? `${window.Shopify.routes.root}search?q=${state.query}`
                : `${window.Shopify.routes.root}collections/all`;
              return html`
                <div class="aa-footer">
                  <a class="aa-SeeAllBtn" href="${destination}">
                    ${hasQuery
                      ? html`View All "<span>${capitalizeWords(state.query)}</span>"`
                      : 'Shop all products'}
                  </a>
                </div>
              `;
            }
          },
        },
      ];
    };

    return options;
  });

  algoliaShopify.hooks.registerHook('beforeAutocompleteMainTemplate', function(_defaultTemplate, templateOptions, elements, displaySuggestions) {
      const { html } = templateOptions;

      const asArray = (v) => Array.isArray(v) ? v : (v == null ? [] : [v]);
      const collectionChildren = asArray(elements?.collections?.props?.children);
      const list = collectionChildren.find(
        (child) =>
          child &&
          child.props &&
          String(child.props.className || '').split(/\s+/).includes('aa-List')
      ) || null;
      const liChildren = asArray(list?.props?.children);
      const liCount = liChildren.length;
      const showSuggestionsHeader = !(displaySuggestions === false && liCount > 0);
      return html`
        <div class="aa-PanelLayout aa-Panel--scrollable">
          <div class="aa-PanelSections">
            <div class="aa-PanelSection--left AAA">
              ${showSuggestionsHeader
                ? html`
                    <div class="aa-SourceHeader">
                      <span class="aa-SourceHeaderTitle">
                        ${algoliaShopify.translations.suggestions}
                      </span>
                    </div>
                    ${elements.querySuggestionsPlugin}
                  `
                : ''}
              <div class="aa-Collection-left">
                ${elements.collections} ${elements.articles} ${elements.pages}
                ${elements.redirectUrlPlugin}
              </div>
            </div>
            <div class="aa-PanelSection--right">
              ${elements.products}
              <div class="aa-Collection-right">
                ${elements.collections}
              </div>
            </div>
          </div>
        </div>
      `;
  });

  algoliaShopify.hooks.registerHook('beforeAutocompleteMainProductsTemplate', function(_defaultTemplate, templateOptions, elements) {
      const { html } = templateOptions;
      return html`
        <div class="aa-PanelLayout aa-Panel--scrollable">
          <div class="aa-PanelSections">
            <div class="aa-PanelSection--left BBB">
                  <div class="aa-SourceHeader">
                    <span class="aa-SourceHeaderTitle">${algoliaShopify.translations.suggestions}</span>
                    <div class="aa-SourceHeaderLine" />
                  </div>
            </div>
            <div class="aa-PanelSection--right">
              ${elements.products}
            </div>
          </div>
        </div>
      `;
  });

  algoliaShopify.hooks.registerHook('beforeAutocompleteNoResultsTemplate', function(_defaultTemplate, templateOptions) {
    const { html, state } = templateOptions;
    if (!hasCompletedAlgoliaQuery(state)) return null;
    return html`
      <div class="aa-PanelLayout aa-Panel--scrollable">
        <p class="aa-NoResultsHeader"> 
          ${algoliaShopify.translation_helpers.no_result_for(state.query)}
        </p>
        <a class="aa-NoResultsLink" href="${window.Shopify.routes.root}search?q=">
          ${algoliaShopify.translations.allProducts}
        </a>
      </div>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeAutocompleteSuggestionsTemplate', function(_defaultTemplate, templateOptions) {
    var { html, item, components } = templateOptions;
    return html`
      <a class="aa-ItemLink aa-ItemWrapper" href="${window.Shopify.routes.root}search?q=${item.query}">
        <div class="aa-ItemContent">
          <div class="aa-ItemContentBody">
            <div class="aa-ItemContentTitle">
              ${capitalizeWords(item.query)}
            </div>
          </div>
        </div>
      </a>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeAutocompleteCollectionsTemplate', function(_defaultTemplate, templateOptions, itemLink) {
    const { html, item, components } = templateOptions;
    return  html`
      <a href="${itemLink}" class="aa-ItemLink">
        <div class="aa-ItemWrapper">
          <div class="aa-ItemContent">
            <div class="aa-ItemContentBody">
              <div class="aa-ItemContentTitle">
                ${item.title}
              </div>
            </div>
          </div>
        </div>
      </a>
    `;
  });

});

// ***************************************************************
// ***               Instant Search custom hooks               ***
// ***************************************************************
document.addEventListener('algolia.hooks.initialize', function() {
  let collectionPromoRenderFrame;

  function getCollectionFacetOptions(defaultFacets) {
    const collectionContext = window.oztrailAlgoliaCollectionContext;
    const collectionFacets = algoliaShopify.collectionFacets;
    const collectionFacetWidgets = algoliaShopify.collectionFacetsWidgets;

    if (!collectionContext || !Array.isArray(collectionFacets) || !Array.isArray(collectionFacetWidgets)) {
      return defaultFacets;
    }

    return {
      ...defaultFacets,
      hidden: algoliaShopify.collectionHiddenFacets || [],
      shown: algoliaShopify.collectionShownFacets || [],
      list: collectionFacets,
      widgets: collectionFacetWidgets,
    };
  }

  function getCollectionHitsPerPage(defaultHitsPerPage) {
    const collectionContext = window.oztrailAlgoliaCollectionContext;
    const collectionHitsPerPage = Number.parseInt(
      algoliaShopify.config.collections_full_results_hits_per_page,
      10
    );

    if (!collectionContext || !Number.isInteger(collectionHitsPerPage) || collectionHitsPerPage < 1) {
      return defaultHitsPerPage;
    }

    if (window.oztrailAlgoliaLoadMore?.isAvailable(algoliaShopify)) {
      return collectionHitsPerPage;
    }

    const promoTiles = Array.isArray(collectionContext.promoTiles)
      ? collectionContext.promoTiles
      : [];
    const renderablePromoTileCount = promoTiles.filter(function(promo) {
      return promo && promo.imageUrl && promo.buttonLink;
    }).length;

    return Math.max(collectionHitsPerPage - renderablePromoTileCount, 1);
  }

  function removeCollectionPromoTiles() {
    document.querySelectorAll('.ais-Hits-item--promo').forEach(function(tile) {
      tile.remove();
    });
  }

  function createCollectionPromoTile(promo) {
    const item = document.createElement('li');
    item.className = 'ais-Hits-item ais-Hits-item--promo';
    item.dataset.promoId = promo.id || '';

    const tile = document.createElement('div');
    tile.className = 'promo-tile';

    const image = document.createElement('img');
    image.src = promo.imageUrl;
    image.alt = promo.imageAlt || '';
    image.className = 'motion-reduce';
    image.loading = 'lazy';
    image.decoding = 'async';

    if (promo.imageWidth) {
      image.width = promo.imageWidth;
    }

    if (promo.imageHeight) {
      image.height = promo.imageHeight;
    }

    const info = document.createElement('div');
    info.className = 'promo-tile--info';

    if (promo.name) {
      const title = document.createElement('h3');
      title.className = 'promo-title__title';
      title.textContent = promo.name;
      info.appendChild(title);
    }

    const link = document.createElement('a');
    link.className = 'promo-title__url';
    link.href = promo.buttonLink;
    link.title = promo.buttonText || '';
    link.textContent = promo.buttonText || '';

    info.appendChild(link);
    tile.appendChild(image);
    tile.appendChild(info);
    item.appendChild(tile);

    return item;
  }

  function renderCollectionPromoTiles(page) {
    removeCollectionPromoTiles();

    const collectionContext = window.oztrailAlgoliaCollectionContext;
    const promos = collectionContext && Array.isArray(collectionContext.promoTiles)
      ? collectionContext.promoTiles
      : [];

    const accumulated = Object.values(algoliaShopify.instantsearch?.search?.renderState || {})
      .find(function(state) { return state.infiniteHits; })?.infiniteHits;
    const includesFirstBatch = accumulated
      ? accumulated.isFirstPage
      : page === 0;

    if (!includesFirstBatch || promos.length === 0) {
      return;
    }

    const hitsList = document.querySelector('#algolia-shopify-instantsearch .ais-Hits-list');

    if (!hitsList) {
      return;
    }

    const productItems = Array.from(hitsList.children).filter(function(item) {
      return item.classList.contains('ais-Hits-item') && !item.classList.contains('ais-Hits-item--promo');
    });

    promos.forEach(function(promo) {
      const productPosition = Number(promo.insertBeforeProduct);
      const targetProduct = productItems[productPosition - 1];

      if (!promo.imageUrl || !promo.buttonLink || !targetProduct) {
        return;
      }

      hitsList.insertBefore(createCollectionPromoTile(promo), targetProduct);
    });
  }

  function collectionPromoTilesWidget() {
    return {
      $$type: 'oztrail.collectionPromoTiles',
      render(renderOptions) {
        const page = renderOptions.results && Number.isInteger(renderOptions.results.page)
          ? renderOptions.results.page
          : 0;

        window.cancelAnimationFrame(collectionPromoRenderFrame);
        collectionPromoRenderFrame = window.requestAnimationFrame(function() {
          renderCollectionPromoTiles(page);
        });
      },
      dispose() {
        window.cancelAnimationFrame(collectionPromoRenderFrame);
        removeCollectionPromoTiles();
      }
    };
  }

  algoliaShopify.hooks.registerHook('beforeInstantSearchConfigurationOptions', function(options) {
    algoliaShopify.translations.relevance = "Recommended";
    algoliaShopify.translations.sortBy = "Sort By:"
    algoliaShopify.translations.showMore = "Show all";
    algoliaShopify.translations.outOfStock = "Sold Out";
    
    algoliaShopify.config.show_products = true; //ensure the results are distinct by plp title
    return window.oztrailAlgoliaLoadMore?.configureRouting(options, algoliaShopify) || options;
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchOptions', function(options) {
    if (options && Array.isArray(options.sortOrders)) {
        options.sortOrders.forEach(order => {
            if (order.value === "shopify_products") {
                order.label = "Recommended"; // Update the label
            }
        });
    }
    options.selector = "#algolia-shopify-instantsearch";

    algoliaShopify.config.show_products = true; //ensure the results are distinct by plp title

    const facets = getCollectionFacetOptions(options.facets);

    // Loop through the facet widgets.
    const widgets = facets.widgets.map(widget => {
      // Only update the refinementList widget params.
      if (widget.name !== 'refinementList') {
        return widget;
      }

      // This updates all `refinementList` widgets.
      // If you only want to update specific facet(s),
      // you can target them by checking the value of `widget.params.container`. 
      return {
        ...widget,
        params: {
          ...widget.params,
          // limit: 10,
          // showMore: true,
        }
      }
    });

    return {
      ...options,
      hitsPerPage: getCollectionHitsPerPage(options.hitsPerPage),
      facets: {
        ...facets,
        widgets
      }
    };
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchAllowParamsArray', function(allowParamsArray) {
    // Ensure the input is an array
    if (typeof allowParamsArray === 'string') {
      // Convert string to an array (e.g., split by commas or based on expected format)
      allowParamsArray = allowParamsArray.split(','); // Adjust the delimiter as needed
    }

    if (Array.isArray(allowParamsArray)) {
      // Modify the array
      allowParamsArray.push('q');
      allowParamsArray.push('ref');
      allowParamsArray.push('utm_medium');
      allowParamsArray.push('utm_campaign');
      allowParamsArray.push('_kx');
    } else {
      console.error('allowParamsArray is not an array and could not be processed.');
      return []; // Return an empty array or handle the error appropriately
    }
    
    return allowParamsArray;
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchFiltersString', function(defaultFilter) {
    const collectionContext = window.oztrailAlgoliaCollectionContext;
    const pathnameMatch = window.location.pathname.match(/\/collections\/([^/]+)/i);
    const collectionHandle = collectionContext && collectionContext.collectionHandle
      ? collectionContext.collectionHandle
      : (pathnameMatch && pathnameMatch.length === 2 ? pathnameMatch[1] : null);
    let filters = defaultFilter || '';

    const escapeFilterValue = function(value) {
      return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    };

    if (collectionHandle) {
      const collectionFilter = `collections:"${escapeFilterValue(collectionHandle)}"`;
      const collectionIDFilterRegex = /collection_ids\s*:\s*"[^"]+"/g;

      if (collectionIDFilterRegex.test(filters)) {
        filters = filters.replace(collectionIDFilterRegex, collectionFilter);
      } else if (collectionContext && !/\bcollections\s*:/.test(filters)) {
        filters = filters ? `${filters} AND ${collectionFilter}` : collectionFilter;
      }
    }

    const currentTags = collectionContext && Array.isArray(collectionContext.currentTags)
      ? [...new Set(collectionContext.currentTags)]
      : [];
    const tagFilters = currentTags
      .filter(function(tag) {
        return typeof tag === 'string' && tag.trim().length > 0;
      })
      .map(function(tag) {
        return `tags:"${escapeFilterValue(tag)}"`;
      });

    if (tagFilters.length > 0) {
      filters = [filters, ...tagFilters].filter(Boolean).join(' AND ');
    }

    return filters;
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function(_defaultTemplate, data, html) {
    const filterCount = (window.location.href.match(/refinementList/g) || []).length;
    const filterText = filterCount > 0 ? `Filters (${filterCount})` : "Filters";

    const sortBy = new URLSearchParams(window.location.search).get("sortBy") || "shopify_products";

    const sortLabels = {
      shopify_products: "Recommended",
      shopify_products_recently_ordered_count_desc: "Best selling",
      shopify_products_price_asc: "Price, Low to High",
      shopify_products_price_desc: "Price, High to Low",

      //zzz Come back to after all the Algolia sort options are implemented in the backend. For now, we will just use the default "Recommended" label for all other sort options.
      //zzz mtbd_shopify_au_products_title_asc: "Name",
      //zzz mtbd_shopify_au_products_title_desc: "Name Z-A",
      //zzz mtbd_shopify_au_products_vendor_asc: "Brand",
      //zzz mtbd_shopify_au_products_vendor_desc: "Brand Z-A",
      //zzz mtbd_shopify_au_products_published_at_desc: "Newest first",
      //zzz mtbd_shopify_au_products_price_ratio_asc: "Discounted, High to Low"
    };
    const sortLabel = sortLabels[sortBy] || "Recommended"; // Fallback to "Recommended"
  
    return html`
      <div class="ais-page">
        <div class="ais-input">
          <div class="ais-search-box-container"></div>
          <div class="ais-input-button">
            <div class="ais-clear-input-icon"></div>
          </div>
        </div>
        <div class="ais-button-container">
          <!-- Placeholder div required for Algolia -->
          <div class="ais-facets-button" style="display: none;"></div>

          <!-- Filters Button -->
          <div class="ais-button" onclick="${() => openCloseModalFacets()}">
            <span class="ais-button-filter-text">${filterText}</span>
            <svg viewBox="0 0 16 16" class="button-icon" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.8 3.2H3.348C3.6792 4.1288 4.5584 4.8 5.6 4.8C6.6416 4.8 7.5208 4.1288 7.852 3.2H15.2C15.6424 3.2 16 2.8424 16 2.4C16 1.9576 15.6424 1.6 15.2 1.6H7.852C7.5208 0.6712 6.6416 0 5.6 0C4.5584 0 3.6792 0.6712 3.348 1.6H0.8C0.3576 1.6 0 1.9576 0 2.4C0 2.8424 0.3576 3.2 0.8 3.2ZM15.2 12.8H7.852C7.5208 11.8712 6.6416 11.2 5.6 11.2C4.5584 11.2 3.6792 11.8712 3.348 12.8H0.8C0.3576 12.8 0 13.1576 0 13.6C0 14.0424 0.3576 14.4 0.8 14.4H3.348C3.6792 15.3288 4.5584 16 5.6 16C6.6416 16 7.5208 15.3288 7.852 14.4H15.2C15.6424 14.4 16 14.0424 16 13.6C16 13.1576 15.6424 12.8 15.2 12.8ZM15.2 7.2H12.652C12.3208 6.2712 11.4416 5.6 10.4 5.6C9.3584 5.6 8.4792 6.2712 8.148 7.2H0.8C0.3576 7.2 0 7.5576 0 8C0 8.4424 0.3576 8.8 0.8 8.8H8.148C8.4792 9.7288 9.3584 10.4 10.4 10.4C11.4416 10.4 12.3208 9.7288 12.652 8.8H15.2C15.6424 8.8 16 8.4424 16 8C16 7.5576 15.6424 7.2 15.2 7.2ZM5.6 1.6C6.0416 1.6 6.4 1.9584 6.4 2.4C6.4 2.8416 6.0416 3.2 5.6 3.2C5.1584 3.2 4.8 2.8416 4.8 2.4C4.8 1.9584 5.1584 1.6 5.6 1.6ZM5.6 14.4C5.1584 14.4 4.8 14.0416 4.8 13.6C4.8 13.1584 5.1584 12.8 5.6 12.8C6.0416 12.8 6.4 13.1584 6.4 13.6C6.4 14.0416 6.0416 14.4 5.6 14.4ZM10.4 8.8C9.9584 8.8 9.6 8.4416 9.6 8C9.6 7.5584 9.9584 7.2 10.4 7.2C10.8416 7.2 11.2 7.5584 11.2 8C11.2 8.4416 10.8416 8.8 10.4 8.8Z" fill="#222222"></path><mask id="mask0_8095:39389" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16" class="__web-inspector-hide-shortcut__"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.8 3.2H3.348C3.6792 4.1288 4.5584 4.8 5.6 4.8C6.6416 4.8 7.5208 4.1288 7.852 3.2H15.2C15.6424 3.2 16 2.8424 16 2.4C16 1.9576 15.6424 1.6 15.2 1.6H7.852C7.5208 0.6712 6.6416 0 5.6 0C4.5584 0 3.6792 0.6712 3.348 1.6H0.8C0.3576 1.6 0 1.9576 0 2.4C0 2.8424 0.3576 3.2 0.8 3.2ZM15.2 12.8H7.852C7.5208 11.8712 6.6416 11.2 5.6 11.2C4.5584 11.2 3.6792 11.8712 3.348 12.8H0.8C0.3576 12.8 0 13.1576 0 13.6C0 14.0424 0.3576 14.4 0.8 14.4H3.348C3.6792 15.3288 4.5584 16 5.6 16C6.6416 16 7.5208 15.3288 7.852 14.4H15.2C15.6424 14.4 16 14.0424 16 13.6C16 13.1576 15.6424 12.8 15.2 12.8ZM15.2 7.2H12.652C12.3208 6.2712 11.4416 5.6 10.4 5.6C9.3584 5.6 8.4792 6.2712 8.148 7.2H0.8C0.3576 7.2 0 7.5576 0 8C0 8.4424 0.3576 8.8 0.8 8.8H8.148C8.4792 9.7288 9.3584 10.4 10.4 10.4C11.4416 10.4 12.3208 9.7288 12.652 8.8H15.2C15.6424 8.8 16 8.4424 16 8C16 7.5576 15.6424 7.2 15.2 7.2ZM5.6 1.6C6.0416 1.6 6.4 1.9584 6.4 2.4C6.4 2.8416 6.0416 3.2 5.6 3.2C5.1584 3.2 4.8 2.8416 4.8 2.4C4.8 1.9584 5.1584 1.6 5.6 1.6ZM5.6 14.4C5.1584 14.4 4.8 14.0416 4.8 13.6C4.8 13.1584 5.1584 12.8 5.6 12.8C6.0416 12.8 6.4 13.1584 6.4 13.6C6.4 14.0416 6.0416 14.4 5.6 14.4ZM10.4 8.8C9.9584 8.8 9.6 8.4416 9.6 8C9.6 7.5584 9.9584 7.2 10.4 7.2C10.8416 7.2 11.2 7.5584 11.2 8C11.2 8.4416 10.8416 8.8 10.4 8.8Z" fill="white"></path></mask><g mask="url(#mask0_8095:39389)"></g></svg>
          </div>

          <!-- Sort Button + Dropdown -->
          <div class="ais-button ais-sort-wrapper" style="border-left: none !important;">
            <div class="ais-sort-toggle" onclick="${() => toggleSortDropdown()}">
              <span class="ais-button-sortby-text">${sortLabel}</span>
              <svg class="sort-chevron" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </div>
            <div class="ais-sort-dropdown" hidden>
              <div class="ais-sort-option" data-value="shopify_products" onclick="${() => sortOptionClicked('shopify_products')}">Recommended</div>
              <div class="ais-sort-option" data-value="shopify_products_recently_ordered_count_desc" onclick="${() => sortOptionClicked('shopify_products_recently_ordered_count_desc')}">Best selling</div>
              <div class="ais-sort-option" data-value="shopify_products_price_asc" onclick="${() => sortOptionClicked('shopify_products_price_asc')}">Price, Low to High</div>
              <div class="ais-sort-option" data-value="shopify_products_price_desc" onclick="${() => sortOptionClicked('shopify_products_price_desc')}">Price, High to Low</div>
            </div>
          </div>
        </div>

        <div class="ais-facets-modal-overlay" onclick="${() => openCloseModalFacets()}"></div>
        <div class="ais-facets">
          <div class="ais-facets-header">Filters</div>
          <div class="ais-facets-modal-heading">Filters<button class="close-button" type="button" aria-label="Close" onclick="${() => openCloseModalFacets()}">X</button></div>
          <div class="ais-current-refined-values-container">
          </div>
          <div class="ais-clear-refinements-container"></div>
          ${data.facets.map(
            facet =>
              html`
                <div class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}">
                  <input class="ais-dropdown-checkbox" type="checkbox" id="${facet.escapedName}" name="dropdown" checked/>
                  <label for="${facet.escapedName}" class="ais-range-slider--header ais-facet--header ais-header">
                    ${facet.title}
                    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>
                  </label>
                  <div class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"></div>
                </div>
              `
          )}
        </div>
        <div class="ais-block">
          <div class="ais-search-header">
            <div class="ais-stats-container"></div>
            <div class="ais-change-display">
              <span class="ais-change-display-block ais-change-display-selected"><i class="fa fa-th-large"></i></span>
              <span class="ais-change-display-list"><i class="fa fa-th-list"></i></span>
            </div>
            <div class="ais-sort">
              ${data.multipleSortOrders
                ? html`
                    ${algoliaShopify.translations.sortBy}
                    <span class="ais-sort-orders-container"></span>
                  `
                : html`
                    ${algoliaShopify.translations.sortBy}
                    ${algoliaShopify.translations.relevance}
                  `}
            </div>
          </div>
          <div class="ais-hits-container ais-results-as-block"></div>
          <div class="oztrail-load-more-status">
            <p data-algolia-load-more-status role="status" aria-live="polite" aria-atomic="true" hidden></p>
            <button class="button button--secondary" type="button" data-algolia-load-more-retry hidden>${window.algoliaLoadMoreLabels?.retry}</button>
          </div>
        </div>
        <div class="ais-pagination-container"></div>
      </div>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(_defaultTemplate, hit, html, components) {
    const hitPriceData = priceData(hit);
    const productMeta = hit.meta && hit.meta.product ? hit.meta.product : {};
    const tags = Array.isArray(hit.tags) ? hit.tags : [];

    const customSaleBadgeIsActive = displayCustomSalesBadge(
      productMeta.sale_badge_text || '',
      productMeta.sale_start_date || '',
      productMeta.sale_end_date || ''
    );
    const freeGift = hit.meta?.custom?.free_gift_gifts;
    const hasFreeGift =
      Array.isArray(freeGift)
        ? freeGift.length > 0
        : Boolean(freeGift);
        
    const isAvailable =
      hit.inventory_available > 0 ||
      hit.inventory_policy === 'continue';

    const primaryBadgePLP = 
        isAvailable
          ? (
              OZTRAIL_AU_B2B_ENABLED
                ? (
                    hitPriceData.clearance
                      ? html`
                          <span class="badge aa-badge badge--bottom-left color-clearance-badge">
                            Clearance
                          </span>
                        `
                      : ''
                  )
                : (
                    customSaleBadgeIsActive &&
                    hit.compare_at_price > hit.price &&
                    productMeta.display_both_sale_badges === true
                      ? html`
                          <span class="badge aa-badge badge--bottom-left color-sale-badge">
                            Sale
                          </span>
                          <span class="badge aa-badge badge--bottom-left color-custom-sale-badge">
                            ${productMeta.sale_badge_text}
                          </span>
                        `
                      : customSaleBadgeIsActive
                        ? html`
                            <span class="badge aa-badge badge--bottom-left color-custom-sale-badge">
                              ${productMeta.sale_badge_text}
                            </span>
                          `
                        : (
                            hit.compare_at_price > hit.price &&
                            tags.includes('Clearance')
                              ? html`
                                  <span class="badge aa-badge badge--bottom-left color-clearance-badge">
                                    Clearance
                                  </span>
                                `
                              : ''
                          )
                  )
            )
          : (
              tags.includes('Exclusive to Anaconda') ||
              tags.includes('Online Exclusive')
                ? ''
                : html`
                    <span class="badge aa-badge badge--bottom-left color-sold-out-badge">
                      ${algoliaShopify.translations.outOfStock}
                    </span>
                  `
            );

      const reviewCount = Number.parseInt(hit.meta?.yotpo?.reviews_count, 10);
      const has_rating = reviewCount > 0 && reviewRatingPercent(hit) > 0;

      const isNewArrival = tags.includes('New Arrivals');

      const isExclusive = tags.includes('Website Only');
      const isExclusiveToAnaconda = !isExclusive && tags.includes('Exclusive to Anaconda');
      const isExclusiveToBCF =
        !isExclusive &&
        !isExclusiveToAnaconda &&
        tags.includes('Online Exclusive');
      
      const isBestSeller = 
            !isNewArrival && !isExclusive && !isExclusiveToAnaconda && !isExclusiveToBCF &&
            tags.includes('Best Seller');

      const isTeamsPick = 
            !isNewArrival && !isExclusive && !isExclusiveToAnaconda && !isExclusiveToBCF && !isBestSeller && 
            tags.includes('Teams Pick');

      
      const customBadges = {
        1: null,
        2: null,
        3: null,
        4: null,
        5: null
      };

      const customBadgePositions = {
        1: 'row',
        2: 'row',
        3: 'row',
        4: 'row',
        5: 'row'
      };

    if (typeof hit.named_tags === 'object' && hit.named_tags !== null) {
      for (let i = 1; i <= 5; i++) {
        const key = `Custom Badge ${i}`;
        const value = hit.named_tags[key];
        const positionValue = hit.named_tags[`${key} Position`];
        const normalizedPosition =
          typeof positionValue === 'string'
            ? positionValue.trim().toLowerCase()
            : '';

        customBadges[i] = value && value.trim() !== "" ? value.trim() : null;

        if (normalizedPosition === 'top left') {
          customBadgePositions[i] = 'top-left';
        } else if (normalizedPosition === 'bottom left') {
          customBadgePositions[i] = 'bottom-left';
        }
      }
    }

    const hasTopLeftCustomBadges = Object.keys(customBadges).some(function (badgeNumber) {
      return customBadges[badgeNumber] && customBadgePositions[badgeNumber] === 'top-left';
    });
    const hasBottomLeftCustomBadges = Object.keys(customBadges).some(function (badgeNumber) {
      return customBadges[badgeNumber] && customBadgePositions[badgeNumber] === 'bottom-left';
    });
    const percentOffFlag = getPercentOffFlag(hit, hitPriceData);
                
    return html`<div
        class="ais-hit ais-product"
        data-algolia-index="${hit.index}"
        data-algolia-position="${hit.productPosition}"
        data-algolia-queryid="${hit.queryID}"
        data-algolia-objectid="${hit.objectID}"
        data-handle="${canonicalHandle(hit)}"
        data-variant-id="${hit.objectID}"
        data-distinct="${hit._distinct}"
        data-product-id="${hit.id}"
        onClick="${() => algoliaShopify.helpers.handleItemClick(hit)}"
      >
        <div class="ais-hit--picture-wrapper">
         <a
              data-algolia-index="${hit.index}"
              data-algolia-position="${hit.productPosition}"
              data-algolia-queryid="${hit.queryID}"
              data-algolia-objectid="${hit.objectID}"
              href="${canonicalLink(hit)}"
            >
            <img
              class="ais-hit--picture"
              src="${algoliaShopify.helpers.mediumImage(hit)}"
              alt="${plpTitle(hit)}"
            />
            ${!hitPriceData.display_club_price && (percentOffFlag || hasTopLeftCustomBadges) && html`
              <span class="ais-hit--badge-overlay ais-hit--badge-overlay--top-left">
                ${percentOffFlag && html`<span class="badge color-custom-sale-badge percent-off-flag">${percentOffFlag}</span>`}
                ${customBadges[1] && customBadgePositions[1] === 'top-left' && html`<span class="badge color-custom-badge-1">${customBadges[1]}</span>`}
                ${customBadges[2] && customBadgePositions[2] === 'top-left' && html`<span class="badge color-custom-badge-2">${customBadges[2]}</span>`}
                ${customBadges[3] && customBadgePositions[3] === 'top-left' && html`<span class="badge color-custom-badge-3">${customBadges[3]}</span>`}
                ${customBadges[4] && customBadgePositions[4] === 'top-left' && html`<span class="badge color-custom-badge-4">${customBadges[4]}</span>`}
                ${customBadges[5] && customBadgePositions[5] === 'top-left' && html`<span class="badge color-custom-badge-5">${customBadges[5]}</span>`}
              </span>
            `}
            ${!hitPriceData.display_club_price && hasBottomLeftCustomBadges && html`
              <span class="ais-hit--badge-overlay ais-hit--badge-overlay--bottom-left">
                ${customBadges[1] && customBadgePositions[1] === 'bottom-left' && html`<span class="badge color-custom-badge-1">${customBadges[1]}</span>`}
                ${customBadges[2] && customBadgePositions[2] === 'bottom-left' && html`<span class="badge color-custom-badge-2">${customBadges[2]}</span>`}
                ${customBadges[3] && customBadgePositions[3] === 'bottom-left' && html`<span class="badge color-custom-badge-3">${customBadges[3]}</span>`}
                ${customBadges[4] && customBadgePositions[4] === 'bottom-left' && html`<span class="badge color-custom-badge-4">${customBadges[4]}</span>`}
                ${customBadges[5] && customBadgePositions[5] === 'bottom-left' && html`<span class="badge color-custom-badge-5">${customBadges[5]}</span>`}
              </span>
            `}
          </a>
        </div>
        <div class="ais-hit--details">
          <a
              data-algolia-index="${hit.index}"
              data-algolia-position="${hit.productPosition}"
              data-algolia-queryid="${hit.queryID}"
              data-algolia-objectid="${hit.objectID}"
              href="${canonicalLink(hit)}"
            >
              <p class="ais-hit--title">
                ${hit.vendor}
              </p>
              <p class="ais-hit--title-model">
                  ${plpTitleModel(hit)}
              </p>
              <p class="ais-hit--subtitle" title="${plpTitle(hit)}">
                 ${plpTitleColour(hit)}
              </p>
              <div class="ais-hit--price-container">
              ${ hitPriceData.display_compare_at_price ?
                  html`<p class="ais-hit--price-striked">${hitPriceData.display_compare_at_price_formatted}</p>
                       <p class="${hitPriceData.catalog_price ? html`ais-hit--b2b-price`: html`ais-hit--sale-price`}">${hitPriceData.display_price_formatted}</p>`
                : html`<p class="${hitPriceData.catalog_price ? html`ais-hit--b2b-price`: html`ais-hit--price`}">${hitPriceData.display_price_formatted}</p>` 
              }
              </div>
              ${OZTRAIL_AU_B2B_ENABLED && hitPriceData.display_compare_at_price && html`
                  <p class="ais-hit--margin"> Margin: ${hitPriceData.margin_formatted}</p>
                `
              }
            
              <div style="display:flex;padding-left: 0.7rem;">
                <div class="yotpoReviews yotpo-sr">
                  <div class="yotpo-sr-container" style="line-height: 25px; height:25px">
                    ${has_rating && html`
                    <div class="yotpo-sr-stars">
                      <div class="yotpo-stars">
                        <div class="yotpo-stars-background"></div>
                        <div class="yotpo-stars-foreground" style="width: ${reviewRatingPercent(hit)}%;"></div>
                      </div>
                    </div>
                    <div class="yotpo-sr-count">
                      <span class="yotpo-sr-count-number" style="font-size: 1.2rem;font-weight:100">(${reviewCount})</span>
                    </div>
                    `}
                  </div>
                </div>
              </div>
            
              ${hitPriceData.display_club_price && html`
                  <div class="ais-hit--badge-container">
                  <span class="ais-hit--club-price">
                    <span class="ais-hit--club-price-label">
                      ${hitPriceData.club_price_applied && html`<svg class="club-price-tick" viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M2 6.4l2.6 2.6L10 3.4" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>`}
                      Club Price
                    </span>
                    <span class="ais-hit--club-price-value">
                      ${hitPriceData.club_price_applied
                        ? `Saving ${hitPriceData.club_saving_formatted}`
                        : hitPriceData.display_club_price_formatted}
                    </span>
                    ${!hitPriceData.club_price_applied && html`<span class="club-price-info" role="button" tabindex="0" aria-haspopup="dialog" aria-expanded="false" aria-label="What is Club price?">
                      <svg class="club-price-info__icon" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><circle cx="8" cy="8" r="7" fill="none" stroke="currentColor" stroke-width="1.5"></circle><circle cx="8" cy="4.8" r="1" fill="currentColor"></circle><path d="M8 7.2v4.6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"></path></svg>
                    </span>`}
                  </span>
                  </div>
              `}
              ${!hitPriceData.display_club_price && html`
              <p class="ais-hit--badge-container">
              ${primaryBadgePLP}
              ${!primaryBadgePLP && html`
                  ${isNewArrival && html`<span class="badge color-new-arrivals-badge">New</span>`}
                  ${isExclusive && html`<span class="badge color-exclusive-badge">Exclusive</span>`}
                  ${isExclusiveToAnaconda && html`<span class="badge color-exclusive-badge">Exclusive To Anaconda</span>`}
                  ${isExclusiveToBCF && html`<span class="badge color-exclusive-badge">Exclusive To BCF</span>`}
                  ${isTeamsPick && html`<span class="badge color-teams-pick-badge">Teams Pick</span>`}
                  ${isBestSeller && html`<span class="badge color-best-seller-badge">Best Seller</span>`}
                  ${customBadges[1] && customBadgePositions[1] === 'row' && html`<span class="badge color-custom-badge-1">${customBadges[1]}</span>`}
                  ${customBadges[2] && customBadgePositions[2] === 'row' && html`<span class="badge color-custom-badge-2">${customBadges[2]}</span>`}
                  ${customBadges[3] && customBadgePositions[3] === 'row' && html`<span class="badge color-custom-badge-3">${customBadges[3]}</span>`}
                  ${customBadges[4] && customBadgePositions[4] === 'row' && html`<span class="badge color-custom-badge-4">${customBadges[4]}</span>`}
                  ${customBadges[5] && customBadgePositions[5] === 'row' && html`<span class="badge color-custom-badge-5">${customBadges[5]}</span>`}
                `}
                ${hasFreeGift && isAvailable && html`<span class="badge color-free-gift-badge">Free Gift</span>`}
              </p>
              `}
          </a>
          ${(isAvailable || hasFreeGift) && !isExclusiveToAnaconda && !isExclusiveToBCF && html`
          <div class="ais-hit--atc-container">
            ${hasFreeGift
              ? html`
                  <a href="${canonicalLink(hit)}" class="button button--full-width button--secondary">
                    View Product
                  </a>
                `
              : html`
                  <product-form data-section-id="template--${hit.object}__product-grid">
                    <form method="post" 
                          action="${routes.cart_add_url}" 
                          id="quick-add-template--${hit.object}__product-grid${hit.id}" 
                          accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">

                      <input type="hidden" name="form_type" value="product" />
                      <input type="hidden" name="utf8" value="✓" />
                      <input type="hidden" name="id" value="${hit.objectID}" class="product-variant-id" />
                      <button id="quick-add-template--${hit.object}__product-grid${hit.id}-submit" type="submit" name="add" 
                              class="ais-hit--atc-button button button--full-width button--secondary" 
                              aria-haspopup="dialog" 
                              aria-labelledby="quick-add-template--${hit.object}__product-grid${hit.id}-submit title-template--${hit.object}__product-grid-${hit.id}" 
                              aria-live="polite" 
                              data-sold-out-message="true">
                        <span>Add to cart</span>
                        <span class="sold-out-message hidden">
                          Sold out
                        </span>
                        <div class="loading__spinner hidden">
                          <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                          </svg>
                        </div>
                      </button>
                      <input type="hidden" name="product-id" value="${hit.id}" />
                      <input type="hidden" name="section-id" value="template--${hit.object}__product-grid" />
                    </form>
                  </product-form>
                `}
          </div>
          `}
        </div>
      </div>`;
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchNoResultTemplate', function(_defaultTemplate, html) {
    return html`
      <div class="ais-hit-empty">
        <div class="ais-hit-empty--title">
          ${algoliaShopify.translations.noResultFound}
        </div>
        <div class="ais-hit-empty--clears">
          ${algoliaShopify.translations.try} ${' '}
          <a class="ais-hit-empty--clear-filters ais-link">
            ${algoliaShopify.translations.clearFilters} ${' '}
          </a>
          ${algoliaShopify.translations.or} ${' '}
          <a class="ais-hit-empty--clear-input ais-link">
            ${algoliaShopify.translations.changeInput}
          </a>
        </div>
      </div>
    `;
  });

  const naturallySortedFacetNames = new Set([
    'meta.custom.capacity',
    'meta.custom.size_inches_',
    'meta.custom.size_qt_',
    'meta.custom.temperature_rating_celsius_',
  ]);
  const naturalFacetCollator = new Intl.Collator('en', {
    numeric: true,
    sensitivity: 'base',
  });
  const sortNaturalFacetValues = (a, b) => {
    const numberA = Number.parseFloat(a.name);
    const numberB = Number.parseFloat(b.name);
    const hasNumberA = !Number.isNaN(numberA);
    const hasNumberB = !Number.isNaN(numberB);

    if (hasNumberA && hasNumberB && numberA !== numberB) {
      return numberA - numberB;
    }
    if (hasNumberA !== hasNumberB) {
      return hasNumberA ? -1 : 1;
    }

    return naturalFacetCollator.compare(a.name, b.name);
  };

  algoliaShopify.hooks.registerHook('beforeInstantSearchFacetParamsOptions', function(params, facet) {
    if (facet.type === 'conjunctive' || facet.type === 'disjunctive') {
      const facetOptions = {
        ...params,
        limit: 10,
        showMore: true,
        showMoreLimit: 1000,
        searchable: false,
        transformItems(items) {

          if (items.length == 1 && facet.name != 'named_tags.On Sale'  && !items[0].isRefined) {
            return [];  // Refinement list will not render if no items
          }

          const cleanText = (text) => text.replace(/[\[\]\"]/g, '');

          return items.map(item => ({
            ...item,
            label: cleanText(item.label),
            highlighted: cleanText(item.highlighted),
          }));
        },
        templates: {
          item(item, { html }) {
            return html`
              <label class="${item.cssClasses.label}">
                ${facet.type === 'disjunctive' &&
                  (item.isRefined
                    ? html`
                        <input
                          type="checkbox"
                          class="${item.cssClasses.checkbox}"
                          checked
                        />
                      `
                    : html`
                        <input type="checkbox" class="${item.cssClasses.checkbox}" />
                      `)}
                ${item.label}
              </label>
            `;
          },
        },
      };

      if (facet.name === 'product_type') {
        delete facetOptions.sortBy;
      } else {
        facetOptions.sortBy = naturallySortedFacetNames.has(facet.name)
          ? sortNaturalFacetValues
          : ["isRefined", "name:asc"];
      }

      return facetOptions;
    }

    if (facet.type == "slider") {
      return {
        ...params,
        pips: true,
        tooltips: true,
      }
    }

    return {
      ...params,
      limit: 1000,
      showMore: false,
      searchable: false,
    }
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchStatsTemplate', function (_defaultTemplate, data, html) {
    return html`
      ${data.query &&
        html`
          <div class="ais-search-header-query">
            Search results for <span class="ais-stats--nb-results">"${data.query}"</span>
          </div>
        `}
      <span class="ais-stats--nb-results">
        ${data.hasOneResult 
          ? '1 product' 
          : `${algoliaShopify.helpers.formatNumber(data.nbHits)} products`}
      </span>
    `;
  });

  algoliaShopify.hooks.registerHook("beforeInstantSearchStartAddWidgets", function () {
    const { configure } = window.algoliaShopify.externals.widgets;
    configureWidget = configure({
      facetingAfterDistinct: false,
    });
    return [configureWidget, collectionPromoTilesWidget()];
  });

  algoliaShopify.hooks.registerHook('afterInstantSearchStartRemoveDefaultWidgets', function(defaultWidgets) {
    const defaultStatsWidget = defaultWidgets.find(
      widget => widget.$$widgetType === 'ais.stats'
    );

    const replacements = window.oztrailAlgoliaLoadMore?.prepare(algoliaShopify, defaultWidgets) || [];
    return [...(defaultStatsWidget ? [defaultStatsWidget] : []), ...replacements];
  });

  function openCloseModalFacets() {
    const facets = document.querySelector(".ais-facets");
    const isShown = facets.classList.toggle("ais-facets__shown");
  
    if (isShown) {
      facets.dataset.scrollY = window.scrollY;
      document.body.style.top = `-${window.scrollY}px`; // keeps the page in place while body is fixed
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden"; // <html>
      document.body.style.position = "fixed"; // prevents rubber-band scroll
      document.body.style.width = "100%";
      document.dispatchEvent(new Event('oztrail:algolia:filters-opened'));
      requestAnimationFrame(() => {
        document.querySelector(".ais-facets").scrollTop = 0;
      });
    } else {
      const filterCount = document.querySelectorAll('.ais-current-refined-values--item').length;
      const filtertext = document.querySelector(".ais-button-filter-text"); 
      filtertext.innerText = filterCount > 0 ? `Filters (${filterCount})` : "Filters";

      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
      document.body.style.position = "";
      document.body.style.width = "";
      document.body.style.top = "";
      window.scrollTo({ top: Number(facets.dataset.scrollY || 0), behavior: "instant" });
      document.dispatchEvent(new Event('oztrail:algolia:filters-closed'));
    }
  }
  
  function toggleSortDropdown() {
    const dropdown = document.querySelector(".ais-sort-dropdown");
    const chevron = document.querySelector(".sort-chevron");
  
    const isOpen = !dropdown.hasAttribute("hidden");
  
    if (isOpen) {
      dropdown.setAttribute("hidden", "");
      chevron.classList.remove("rotated");
    } else {
      dropdown.removeAttribute("hidden");
      chevron.classList.add("rotated");
    }
  }
  
  function sortOptionClicked(sortOptionValue) {
    const sortBySelect = document.querySelector(".ais-SortBy-select");
    if (sortBySelect) {
      sortBySelect.value = sortOptionValue;
      
      const sortByText = document.querySelector(".ais-button-sortby-text");
      if (sortByText) {
        const selectedOption = Array.from(sortBySelect.options).find(option => option.value === sortOptionValue);
        if (selectedOption) {
          sortByText.innerText = selectedOption.text;

          const event = new Event("change", { bubbles: true });
          sortBySelect.dispatchEvent(event);
        }
      }
    }

    toggleSortDropdown();
  }

});

// ***************************************************************
// ***                      Helper Functions                   ***
// ***************************************************************
function formatPrice(value) {
  return algoliaShopify.formatMoney(Number(value) * 100);
};

function reviewRatingPercent(item) {
  const rating = Number.parseFloat(item.meta?.yotpo?.reviews_average);

  if (!Number.isFinite(rating)) {
    return 0;
  }

  return (Math.min(Math.max(rating, 0), 5) / 5) * 100;
};

function priceData(hit) {
  const clubPrice = Number.parseFloat(hit.meta?.custom?.club_price);
  const clubPricingEnabled =
    hit.meta?.custom?.club_pricing_enabled === true ||
    hit.meta?.custom?.club_pricing_enabled === 'true';
  const clubPricingActive = document.body.dataset.oztrailClubPricingActive === 'true';
  // B2B buyers are excluded from Club pricing by the app, so they see no Club offer either
  const isB2BCustomer = document.body.dataset.oztrailCustomerB2b === 'true';
  const hasClubPrice =
    clubPricingActive && clubPricingEnabled && !isB2BCustomer &&
    Number.isFinite(clubPrice) && clubPrice > 0 && clubPrice < hit.price;
  const useClubPrice = hasClubPrice && document.body.dataset.oztrailCustomerSignedIn === 'true';

  var priceData = {
    catalog_price: false,
    price: useClubPrice ? clubPrice : hit.price,
    display_price_formatted: '',
    compare_at_price: hit.compare_at_price,
    display_compare_at_price_formatted: '',
    club_price: hasClubPrice ? clubPrice : null,
    display_club_price: hasClubPrice,
    display_club_price_formatted: '',
    club_price_applied: useClubPrice,
    club_saving_formatted: '',
    clearance: false
  };

  // Club price applied: compare against the Non-Club price, never the RRP, so no strike-through
  priceData.display_compare_at_price = !useClubPrice && priceData.compare_at_price > priceData.price;

  priceData.display_compare_at_price_formatted = formatPrice(priceData.compare_at_price);
  priceData.display_price_formatted = formatPrice(priceData.price);
  priceData.display_club_price_formatted = hasClubPrice ? formatPrice(priceData.club_price) : '';
  // Whole-dollar savings drop the cents, e.g. $10 rather than $10.00
  priceData.club_saving_formatted = hasClubPrice
    ? formatPrice(Math.round((hit.price - clubPrice) * 100) / 100).replace(/\.00$/, '')
    : '';

  return priceData;
};


// Rounds down so the flag never overstates the saving. Liquid version: snippets/percent-off-flag.liquid
function getPercentOffFlag(hit, hitPriceData) {
  const config = window.percentOffFlag;
  const isAvailable = hit.inventory_available > 0 || hit.inventory_policy === 'continue';
  const isB2BCustomer = document.body.dataset.oztrailCustomerB2b === 'true';
  if (!config?.tiles || !isAvailable || isB2BCustomer) return '';
  if (hitPriceData.display_club_price || !hitPriceData.display_compare_at_price) return '';

  // Whole cents, so floating point prices cannot tip a flag down a percent or a dollar
  const compareCents = Math.round(hit.compare_at_price * 100);
  const savingCents = compareCents - Math.round(hit.price * 100);
  const percentOff = Math.floor((savingCents * 100) / compareCents);
  if (percentOff < config.minPercent || savingCents < config.minSaving * 100) return '';

  if (config.format === 'amount') {
    const amount = formatPrice(Math.floor(savingCents / 100)).replace(/\.00$/, '');
    return [config.amountBefore, amount, config.amountAfter].filter(Boolean).join(' ');
  }
  return [config.percentBefore, `${percentOff}%`, config.percentAfter].filter(Boolean).join(' ');
}


function displayCustomSalesBadge(saleBadgeText, saleStartDate, saleEndDate){
  var todayDate = new Date();
  if (saleStartDate){
    saleStartDate = new Date(saleStartDate);
  } else {
    return false
  }
  if (saleEndDate){
    saleEndDate = new Date(saleEndDate);
  } else {
    return false
  }

  return ( todayDate >= saleStartDate && todayDate <= saleEndDate && saleBadgeText )
}

function plpTitle(hit) {
  var res = hit.title;
  if (hit.meta && hit.meta.product && hit.meta.product.plp_title) {
    res = hit.meta.product.plp_title;
  } else if (
    !hit._distinct &&
    hit.variant_title &&
    hit.variant_title !== 'Default Title' &&
    hit.variant_title !== 'Default'
  ) {
    res += ' (' + hit.variant_title + ')';
  }

  return res;
};
function plpTitleModel(hit) {
  var res = hit.title;
  if (hit.meta && hit.meta.product && hit.meta.product.plp_title) {

    //Remove the colour section from the PLP title
    const parts = hit.meta.product.plp_title.split(' - '); // Split the text into an array using ' - ' as the separator
    res = parts[0]; // Get the first part of the array

    //Remove Vendor from the plp title
    const regex = new RegExp(hit.vendor, "i");
    res = res.replace(regex, "");

  } else if (
    !hit._distinct &&
    hit.variant_title &&
    hit.variant_title !== 'Default Title' &&
    hit.variant_title !== 'Default'
  ) {
    res += ' (' + hit.variant_title + ')';
  }
  res = res.trim();
  return res.trim();
};
function plpTitleColour(hit) {
  var res = hit.title;
  if (hit.meta && hit.meta.product && hit.meta.product.plp_title) {

    //Return the colour section from the PLP title
    const parts = hit.meta.product.plp_title.split(' - '); // Split the text into an array using ' - ' as the separator
    res = parts.slice(1).join(' - '); //parts[1]; // Get the first part of the array
  } else if (
    !hit._distinct &&
    hit.variant_title &&
    hit.variant_title !== 'Default Title' &&
    hit.variant_title !== 'Default'
  ) {
    res += ' (' + hit.variant_title + ')';
  }

  return res;
};
function canonicalHandle(hit) {
  var res = hit.handle;

  if (hit.meta && hit.meta.product && hit.meta.product.canonical) {
    res = hit.meta.product.canonical;
  }

  return res;
};
function canonicalLink(hit) {
  const addVariantId = hit.objectID !== hit.id;
  var handle = hit.handle;

  if (hit.meta && hit.meta.product && hit.meta.product.canonical) {
    handle = hit.meta.product.canonical;
  }

  return (
    '/products/' + handle
  );
};

function capitalizeWords(str) {
  return str
    .split(' ')
    .map(word => word.length > 0
      ? word.charAt(0).toUpperCase() + word.slice(1)
      : word
    )
    .join(' ');
}


// ***************************************************************
// ***         Sticky header Helper Functions                  ***
// ***************************************************************

let algoliaPanelTopFrame = null;
let algoliaPanelTopTimeout = null;
let algoliaPanelTopLastValue = null;

function algoliaDebugRect(element) {
  if (!element) return null;

  const rect = element.getBoundingClientRect();
  const styles = window.getComputedStyle(element);

  return {
    selector: element.tagName.toLowerCase() + (element.id ? `#${element.id}` : ''),
    classes: element.className || '',
    rectTop: rect.top,
    rectBottom: rect.bottom,
    rectHeight: rect.height,
    offsetTop: element.offsetTop,
    offsetHeight: element.offsetHeight,
    stylePosition: styles.position,
    styleTop: styles.top,
    styleMarginTop: styles.marginTop,
    inlineStyle: element.getAttribute('style') || '',
  };
}

function algoliaSearchIsActive() {
  const activeElement = document.activeElement;

  return Boolean(
    document.querySelector('.aa-Panel') ||
      (
        activeElement &&
        activeElement.matches &&
        activeElement.matches('.aa-Input, #pd-main-searchbox-input')
      )
  );
}

function logAlgoliaPanelTopDebug(reason, details) {
  if (!algoliaSearchIsActive() && reason === 'scroll') return;

  const sectionHeader = document.querySelector('.section-header');
  const stickyHeader = document.querySelector('sticky-header');
  const headerWrapper = document.querySelector('.header-wrapper');
  const aaPanel = document.querySelector('.aa-Panel');
  const aaPanelLayout = document.querySelector('.aa-PanelLayout');
  const searchInput = document.querySelector('#pd-main-searchbox-input, .aa-Input');
  const activeElement = document.activeElement;
  const rootStyles = window.getComputedStyle(document.documentElement);
  const bodyStyles = window.getComputedStyle(document.body);
}

function getAlgoliaHeaderCandidates() {
  const desktopSearch = window.matchMedia('(min-width: 1025px)').matches
    ? document.querySelector('.header--nav2 .header--search-inline .aa-Form')
    : null;

  return [
    desktopSearch,
    document.querySelector('.section-header'),
    document.querySelector('sticky-header'),
    document.querySelector('.header-wrapper'),
  ]
    .filter(Boolean)
    .filter(function (element, index, elements) {
      return elements.indexOf(element) === index;
    })
    .map(function (element) {
      const rect = element.getBoundingClientRect();

      return {
        element,
        label: element.tagName.toLowerCase() + (element.id ? `#${element.id}` : ''),
        bottom: rect.bottom,
        height: rect.height,
        offsetHeight: element.offsetHeight,
      };
    });
}

function setAlgoliaPanelTop(reason = 'manual') {
  const candidates = getAlgoliaHeaderCandidates();
  const headerCandidate =
    candidates.find(function (candidate) {
      return candidate.bottom > 0 && candidate.height > 0;
    }) || candidates[0];

  if (!headerCandidate) return;

  const visualViewportTop = window.visualViewport
    ? window.visualViewport.offsetTop
    : 0;
  const rawHeaderBottom = Math.max(
    0,
    headerCandidate.bottom + visualViewportTop
  );
  const shouldPreservePreviousValue =
    algoliaSearchIsActive() &&
    rawHeaderBottom === 0 &&
    algoliaPanelTopLastValue !== null;
  const headerBottom = shouldPreservePreviousValue
    ? algoliaPanelTopLastValue
    : rawHeaderBottom;
  const cssVariableBefore = document.documentElement.style.getPropertyValue(
    '--oz-aa-panel-top'
  );

  if (headerBottom > 0) {
    algoliaPanelTopLastValue = headerBottom;
  }

  document.documentElement.style.setProperty(
    '--oz-aa-panel-top',
    `${headerBottom}px`
  );

  logAlgoliaPanelTopDebug(reason, {
    chosenHeader: headerCandidate.label,
    headerCandidates: candidates.map(function (candidate) {
      return {
        label: candidate.label,
        bottom: candidate.bottom,
        height: candidate.height,
        offsetHeight: candidate.offsetHeight,
      };
    }),
    rawHeaderBottom,
    preservedPreviousValue: shouldPreservePreviousValue,
    cssVariableBefore,
    headerBottom,
  });
}

function updateAlgoliaPanelTop(options = {}) {
  const shouldSettle = options && options.settle === true;
  const reason = options && options.reason ? options.reason : options.type || 'manual';

  if (algoliaPanelTopFrame) {
    cancelAnimationFrame(algoliaPanelTopFrame);
  }

  algoliaPanelTopFrame = requestAnimationFrame(function () {
    algoliaPanelTopFrame = null;
    setAlgoliaPanelTop(reason);

    if (!shouldSettle) return;

    requestAnimationFrame(function () {
      setAlgoliaPanelTop(`${reason}:next-frame`);
    });

    clearTimeout(algoliaPanelTopTimeout);
    algoliaPanelTopTimeout = setTimeout(function () {
      setAlgoliaPanelTop(`${reason}:settled`);
    }, 180);
  });
}

window.addEventListener('resize', function () {
  updateAlgoliaPanelTop({ reason: 'resize' });
});
window.addEventListener('scroll', function () {
  if (!algoliaSearchIsActive()) return;

  updateAlgoliaPanelTop({ reason: 'scroll' });
}, { passive: true });

document.addEventListener('focusin', function (event) {
  if (event.target.matches('.aa-Input, #pd-main-searchbox-input')) {
    updateAlgoliaPanelTop({ reason: 'focusin', settle: true });
  }
});

document.addEventListener('input', function (event) {
  if (event.target.matches('.aa-Input, #pd-main-searchbox-input')) {
    updateAlgoliaPanelTop({ reason: 'input', settle: true });
  }
});

document.addEventListener('algolia.hooks.initialize', function () {
  updateAlgoliaPanelTop({ reason: 'algolia.hooks.initialize', settle: true });
});
